import DefaultGrouping from './default';

export default class DateGrouping extends DefaultGrouping {
  constructor() {
    super();

    this.ungroupedName = 'No Date';
    // sort branches based on their id (constructed in buildTree)
    this.sortingKey = 'id';
  }
}



// WEBPACK FOOTER //
// ./project/groupings/date.js